import axios from "axios";
import {soNumeros} from "@/helps/util";

export function getCEP(cep) {
    return new Promise((resolve, reject) => {
        axios.get(`https://viacep.com.br/ws/${soNumeros(cep)}/json/`, {}).then((res) => {
            resolve(res)
        }).catch(error => {
            reject(error)
        });
    })
}

